export type DataTableSettingsStateType = {
  customWidgetTitle: string;
  density: string;
  rowStripes?: boolean;
  widgetTitle: string;
  widgetTitleAlignment: string;
};

export const dataTableDefaultSettings: DataTableSettingsStateType = {
  customWidgetTitle: "",
  density: "standard",
  rowStripes: false,
  widgetTitle: "none",
  widgetTitleAlignment: "left",
};